<template>
    <div>
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>

        <b-modal size="lg" id="change-request" title="Değişiklik Talebi" no-close-on-esc no-close-on-backdrop>
            <draft-offer-change-request v-model="changeRequestData"></draft-offer-change-request>
            <template #modal-footer><v-executer text="Talebi Kaydet" :action="addChangeRequest"></v-executer></template>
        </b-modal>

        <b-modal id="verification" title="E-posta İle Doğrulama" no-close-on-esc no-close-on-backdrop>
            <draft-offer-verification v-model="codeData" :id="id"></draft-offer-verification>
            <template #modal-footer><v-executer text="Teklifi Onayla" :disabled="!c_codeValid" :loading="accepting" :action="acceptAll"></v-executer></template>
        </b-modal>

        <b-card>
            <b-overlay :show="detailLoading" opacity="1" variant="white" rounded="sm" :class="{'p-1':detailLoading}">
                <template-generator-preview v-if="detail.Scheme" :layout="detail.Scheme">
                    <div v-if="totalUnsavedChanges > 0" class="bg-warning text-white rounded py-50 px-1 mb-1 sticky-alert">
                        Toplam {{totalUnsavedChanges}} adet iletilmemiş değişiklik talebiniz bulunmaktadır.
                    </div>
                    <div class="table-responsive mt-1">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th colspan="3" class="text-center bg-light-primary">Başlangıç</th>
                                    <th colspan="3" class="text-center bg-light-success">Bitiş</th>
                                    <th colspan="3" class="text-center bg-light-info">Tutar</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <th>Durum</th>
                                    <th class="w-10">İl</th>
                                    <th class="w-10">İlçe</th>
                                    <th class="w-12">Mahalle</th>
                                    <th class="w-10">İl</th>
                                    <th class="w-10">İlçe</th>
                                    <th class="w-12">Mahalle</th>
                                    <th class="w-12">Tır/Treyler (TL)</th>
                                    <th class="w-12">Kırkayak (TL)</th>
                                    <th class="w-12">Kamyon (TL)</th>
                                    <th class="text-nowrap">Değişiklik Talepleri</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item,index) in detail.PricesOfRoutes">
                                    <tr :key="'d_'+index">
                                        <td>
                                            <div class="d-flex align-items-center justify-content-center">
                                                <span class="material-icons-outlined text-success" v-if="getGeneralStatus(item)">check_circle</span>
                                                <span class="material-icons-outlined text-warning" v-else>hourglass_bottom</span>
                                            </div>
                                        </td>
                                        <td>{{item.StartProvinceName || '-'}}</td>
                                        <td>{{item.StartDistrictName || '-'}}</td>
                                        <td>{{item.StartNeighbourhoodName || '-'}}</td>
                                        <td>{{item.EndProvinceName || '-'}}</td>
                                        <td>{{item.EndDistrictName || '-'}}</td>
                                        <td>{{item.EndNeighbourhoodName || '-'}}</td>
                                        <td>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center" v-if="item.TreylerRoutePriceStr">
                                                    <span class="material-icons-outlined text-warning" v-if="item.TreylerStatus == 0">hourglass_bottom</span>
                                                    <span class="material-icons-outlined text-success" v-if="item.TreylerStatus == 1">check_circle</span>
                                                    <span class="ml-50">{{item.TreylerRoutePriceStr || '-'}}</span>
                                                </div>
                                                <span v-else>-</span>
                                                <button v-if="detail.AgreementStep == 0 && item.TreylerRoutePriceStr && detail.IsCanChangeable && !expired" :disabled="hasAnyUnsavedChange(item,'TREYLER')" v-on:click="changeRequest(item,'CHANGE_PRICE','TREYLER',item.TreylerRoutePriceStr)" v-b-tooltip.noninteractive.hover.bottom title="Treyler Tutar Değişikliği Talebi" class="btn btn-xs btn-icon btn-flat-primary ml-25">
                                                    <feather-icon icon="RepeatIcon"></feather-icon>
                                                </button>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center" v-if="item.KirkayakRoutePriceStr">
                                                    <span class="material-icons-outlined text-warning" v-if="item.KirkayakStatus == 0">hourglass_bottom</span>
                                                    <span class="material-icons-outlined text-success" v-if="item.KirkayakStatus == 1">check_circle</span>
                                                    <span class="ml-50">{{item.KirkayakRoutePriceStr || '-'}}</span>
                                                </div>
                                                <span v-else>-</span>
                                                <button v-if="detail.AgreementStep == 0 && item.KirkayakRoutePriceStr && detail.IsCanChangeable && !expired" :disabled="hasAnyUnsavedChange(item,'KIRKAYAK')" v-on:click="changeRequest(item,'CHANGE_PRICE','KIRKAYAK',item.KirkayakRoutePriceStr)" v-b-tooltip.noninteractive.hover.bottom title="Kırkayak Tutar Değişikliği Talebi" class="btn btn-xs btn-icon btn-flat-primary ml-25">
                                                    <feather-icon icon="RepeatIcon"></feather-icon>
                                                </button>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center" v-if="item.KamyonRoutePriceStr">
                                                    <span class="material-icons-outlined text-warning" v-if="item.KamyonStatus == 0">hourglass_bottom</span>
                                                    <span class="material-icons-outlined text-success" v-if="item.KamyonStatus == 1">check_circle</span>
                                                    <span class="ml-50">{{item.KamyonRoutePriceStr || '-'}}</span>
                                                </div>
                                                <span v-else>-</span>
                                                <button v-if="detail.AgreementStep == 0 && item.KamyonRoutePriceStr && detail.IsCanChangeable && !expired" :disabled="hasAnyUnsavedChange(item,'KAMYON')" v-on:click="changeRequest(item,'CHANGE_PRICE','KAMYON',item.KamyonRoutePriceStr)" v-b-tooltip.noninteractive.hover.bottom title="Kamyon Tutar Değişikliği Talebi" class="btn btn-xs btn-icon btn-flat-primary ml-25">
                                                    <feather-icon icon="RepeatIcon"></feather-icon>
                                                </button>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <button class="btn btn-success btn-sm text-nowrap mx-25 w-100" v-if="item.AllChangeRequests.length" v-on:click="item.ShowHistory = !item.ShowHistory">{{item.ShowHistory ? 'Gizle' : 'Göster'}}</button>
                                                <span v-else>Yok</span>
                                                <!-- <button class="btn btn-sm btn-secondary text-nowrap w-100 mx-25" :disabled="hasAnyUnsavedChange(item,'ROUTE_ERROR')" v-b-tooltip.noninteractive.hover.bottom title="Rota Değişikliği Talebi" v-on:click="changeRequest(item,'ROUTE_ERROR','ROUTE_ERROR')">Rota</button>
                                                <button class="btn btn-sm btn-warning text-nowrap w-100 mx-25" :disabled="hasAnyUnsavedChange(item,'OTHER')" v-b-tooltip.noninteractive.hover.bottom title="Diğer Değişikliği Talebi" v-on:click="changeRequest(item,'OTHER','OTHER')">Diğer</button> -->
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="item.AllChangeRequests.length > 0 && item.ShowHistory" :key="'r_'+index">
                                        <td class="bg-light-secondary" colspan="150">
                                            <h5 class="my-50 text-secondary">Değişiklik Geçmişi</h5>
                                            <table class="table table-sm table-bordered">
                                                <thead>
                                                    <tr>
                                                        <!-- <th class="w-20">Değişiklik Nedeni</th> -->
                                                        <th class="w-20 bg-white">Araç</th>
                                                        <th class="w-20 bg-white">Talep Edilen Tutar (TL)</th>
                                                        <th class="w-20 bg-white text-nowrap">İstek Tarihi</th>
                                                        <th class="w-20 bg-white text-nowrap">Yanıtlanma Tarihi</th>
                                                        <th class="w-20 bg-white">Açıklama</th>
                                                        <th class="bg-white">Durum</th>
                                                        <th class="bg-white" v-if="detail.AgreementStep == 0 && item.AllChangeRequests.filter(r=>r.Unsaved).length > 0">İşlem</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(req,ci) in item.AllChangeRequests" :key="'req_'+ci" class="bg-white"> 
                                                        <!-- <td><strong>{{req.Reason || "-"}}</strong></td> --> 
                                                        <td class="px-50 py-25">{{req.Type == 'TREYLER' ? 'TIR/TREYLER' : req.Type}}</td> 
                                                        <td class="px-50 py-25">
                                                            <template v-if="req.ReasonCode == 'ROUTE_ERROR'">
                                                                <strong>Talep Edilen Rota: </strong>
                                                                <template v-if="req.StartProvinceName">{{req.StartProvinceName}}</template>
                                                                <template v-if="req.StartDistrictName">, {{req.StartDistrictName}}</template>
                                                                <template v-if="req.StartNeighbourhoodName">, {{req.StartNeighbourhoodName}}</template>
                                                                <template v-if="req.EndProvinceName"> -> {{req.EndProvinceName}}</template>
                                                                <template v-if="req.EndDistrictName">, {{req.EndDistrictName}}</template>
                                                                <template v-if="req.EndNeighbourhoodName">, {{req.EndNeighbourhoodName}}</template>
                                                            </template>
                                                            <template v-else-if="req.ReasonCode == 'CHANGE_PRICE'">
                                                                {{req.PriceStr}}
                                                            </template>
                                                            <template v-else>-</template>
                                                        </td>
                                                        <td class="text-nowrap px-50 py-25">{{req.CreatedDate || '-'}}</td>
                                                        <td class="text-nowrap px-50 py-25">{{req.ActionDate || '-'}}</td>
                                                        <td>{{req.Description || "-"}}</td>
                                                        <td class="text-center align-middle px-50 py-25">
                                                            <span class="material-icons-outlined text-warning d-block" v-if="req.Status == 0">hourglass_bottom</span>
                                                            <span class="material-icons-outlined text-success d-block" v-else-if="req.Status == 1">check_circle</span>
                                                            <span class="material-icons-outlined text-danger d-block" v-else-if="req.Status == 2">cancel</span>
                                                        </td>
                                                        <td class="px-50 py-25" v-if="detail.AgreementStep == 0 && item.AllChangeRequests.filter(r=>r.Unsaved).length > 0">
                                                            <button class="btn btn-sm btn-danger" v-if="req.Unsaved" v-on:click="deleteChangeRequest(req,item,ci)">Vazgeç</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="alert alert-warning mb-0" v-if="detail.AgreementStep == 0 && detail.IsCanChangeable && !expired">
                        <div class="alert-body">
                            Bir teklif için toplam <strong>2 adet</strong> değişiklik talebi gönderme hakkınız bulunmaktadır. Tüm değişiklik isteklerinizi talep ettiğinizden emin olunuz.
                        </div>
                    </div>
                    <div class="alert alert-secondary mb-0" v-if="detail.AgreementStep == 0 && !detail.IsCanChangeable && !expired">
                        <div class="alert-body">
                            Teklif için değişiklik talep hakkınız dolmuştur.
                        </div>
                    </div>
                    <div class="alert alert-danger mb-0" v-if="expired">
                        <div class="alert-body">
                            Teklif yanıtlama süresi geçmiştir.
                        </div>
                    </div>
                    <div class="text-right mt-1" v-if="detail.AgreementStep == 0 && !expired">
                        <v-executer :loading="loading" :disabled="detail.HasActiveChangeRequest" :variant="detail.HasActiveChangeRequest ? 'warning' : 'primary'" :text="detail.HasActiveChangeRequest ? 'Değerlendirme Bekleyen Talepler Var' :'Doğrula ve Teklifi Onayla'" :action="agreementVerification" v-if="totalUnsavedChanges == 0"></v-executer>
                        <v-executer :loading="loading" text="Değişiklik Taleplerini İlet" :action="sendChangeRequests" v-else></v-executer>
                    </div>
                </template-generator-preview>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
import {BCard,BOverlay,VBTooltip} from 'bootstrap-vue'
import CustomerApi from '@/api/customer'
import TemplateGeneratorPreview from '@/views/template-generator/components/TemplateGeneratorPreview.vue'
import DraftOfferChangeRequest from './components/DraftOfferChangeRequest.vue'
import DraftOfferVerification from './components/DraftOfferVerification.vue'
import randomatic from 'randomatic'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        BOverlay,
        TemplateGeneratorPreview,
        DraftOfferChangeRequest,
        DraftOfferVerification
    },
    directives:{
        "b-tooltip":VBTooltip,
    },
    data() {
        return {
            loading:false,
            accepting:false,
            detailLoading:false,
            id:this.$route.params.id,
            detail:{},
            codeData:{
                code:""
            },
            changeRequestData:{
                Id:null,
                DraftOfferPriceChangeRequestReasonId:null,
                Description:null,
                PriceStr:null,
                Price:null,
                Reason:null,
                ReasonCode:null,
                Data:{},
                Type:null,
                Route:{
                    StartProvinceId:null,
                    StartProvinceName:null,
                    StartDistrictId:null,
                    StartDistrictName:null,
                    StartNeighbourhoodId:null,
                    StartNeighbourhoodName:null,
                    EndProvinceId:null,
                    EndProvinceName:null,
                    EndDistrictId:null,
                    EndDistrictName:null,
                    EndNeighbourhoodId:null,
                    EndNeighbourhoodName:null,
                }
            }
        }
    },
    mounted(){
        this.getDetail()
    },
    methods:{
        back(){
            this.$router.push({name:'customer-draft-offer'})
        },
        clearForm(){
            this.changeRequestData.Id = null
            this.changeRequestData.DraftOfferPriceChangeRequestReasonId = null
            this.changeRequestData.Description = null
            this.changeRequestData.PriceStr = null
            this.changeRequestData.Price = null
            this.changeRequestData.Reason = null
            this.changeRequestData.ReasonCode = null
            this.changeRequestData.Data = {}
            this.changeRequestData.Type = null
            this.changeRequestData.Route.StartProvinceId = null
            this.changeRequestData.Route.StartProvinceName = null
            this.changeRequestData.Route.StartDistrictId = null
            this.changeRequestData.Route.StartDistrictName = null
            this.changeRequestData.Route.StartNeighbourhoodId = null
            this.changeRequestData.Route.StartNeighbourhoodName = null
            this.changeRequestData.Route.EndProvinceId = null
            this.changeRequestData.Route.EndProvinceName = null
            this.changeRequestData.Route.EndDistrictId = null
            this.changeRequestData.Route.EndDistrictName = null
            this.changeRequestData.Route.EndNeighbourhoodId = null
            this.changeRequestData.Route.EndNeighbourhoodName = null
        },
        getDetail(){
            if(this.id != "0" || this.id != 0){
                this.detailLoading = true
                CustomerApi.DraftOffer.DetailWithChangeRequest(this.id).then(res=>{
                    this.detail = this.configureDetail(res.data.Data)
                    this.detailLoading = false
                }).catch(err=>{
                    this.detailLoading = false
                })
            }
        },
        configureDetail(data){
            data.PricesOfRoutes = data.PricesOfRoutes.map(d=>{ 
                let otherChangeRequests = d.OtherChangeRequests || []
                let routeChangeRequests = d.RouteChangeRequests || []
                let kamyonChangeRequests = d.KamyonChangeRequests || []
                let treylerChangeRequests = d.TreylerChangeRequests || []
                let kirkayakChangeRequests = d.KirkayakChangeRequests || []
                
                let allChangeRequests = []
                allChangeRequests.push(...otherChangeRequests.map(c=>{return{...c,Type:"OTHER"}}))
                allChangeRequests.push(...routeChangeRequests.map(c=>{return{...c,Type:"ROUTE_ERROR"}}))
                allChangeRequests.push(...kamyonChangeRequests.map(c=>{return{...c,Type:"KAMYON"}}))
                allChangeRequests.push(...treylerChangeRequests.map(c=>{return{...c,Type:"TREYLER"}}))
                allChangeRequests.push(...kirkayakChangeRequests.map(c=>{return{...c,Type:"KIRKAYAK"}}))

                return{
                    ...d,
                    Id:randomatic("A0",10),
                    AllChangeRequests:allChangeRequests,
                    ShowHistory:false,
                    Status:0
                } 
            })
            return data
        },
        hasAnyUnsavedChange(data,type){
            return data.AllChangeRequests.filter(cr=>cr.Status == 0 && cr.Type == type).length > 0 ? true : false
        },
        getGeneralStatus(item){
            return item.AllChangeRequests.length == item.AllChangeRequests.filter(c=> c.Status == 1 || c.Status == 2).length ? true : false
        },
        changeRequest(item,reasonCode,type,price){
            this.clearForm()
            this.changeRequestData.Id = item.Id
            this.changeRequestData.ReasonCode = reasonCode
            this.changeRequestData.Data = item
            this.changeRequestData.Price = price  
            this.changeRequestData.Type = type || null  
            this.changeRequestData.Route.StartProvinceId = item.StartProvinceId
            this.changeRequestData.Route.StartProvinceName = item.StartProvinceName
            this.changeRequestData.Route.StartDistrictId = item.StartDistrictId
            this.changeRequestData.Route.StartDistrictName = item.StartDistrictName
            this.changeRequestData.Route.StartNeighbourhoodId = item.StartNeighbourhoodId
            this.changeRequestData.Route.StartNeighbourhoodName = item.StartNeighbourhoodName
            this.changeRequestData.Route.EndProvinceId = item.EndProvinceId
            this.changeRequestData.Route.EndProvinceName = item.EndProvinceName
            this.changeRequestData.Route.EndDistrictId = item.EndDistrictId
            this.changeRequestData.Route.EndDistrictName = item.EndDistrictName
            this.changeRequestData.Route.EndNeighbourhoodId = item.EndNeighbourhoodId
            this.changeRequestData.Route.EndNeighbourhoodName = item.EndNeighbourhoodName
            this.$showModal('change-request')
        },
        addChangeRequest(){
            let route = this.detail.PricesOfRoutes.find( r=> r.Id == this.changeRequestData.Id)
            if(route){
                this.$set(route,"Status",0)
                let DBID = null

                if(this.changeRequestData.Type == "KAMYON") {
                    this.$set(route,"KamyonStatus",0)
                    DBID = route.KamyonRouteId
                }
                else if(this.changeRequestData.Type == "TREYLER"){
                    this.$set(route,"TreylerStatus",0)
                    DBID = route.TreylerRouteId
                }
                else if(this.changeRequestData.Type == "KIRKAYAK"){
                    this.$set(route,"KirkayakStatus",0)
                    DBID = route.KirkayakRouteId
                }else{
                    DBID = route.KamyonRouteId || route.TreylerRouteId || route.KirkayakRouteId
                }

                route.AllChangeRequests.push({
                    Id:this.changeRequestData.Id,
                    DBID:DBID,
                    Description:this.changeRequestData.Description,
                    DraftOfferPriceChangeRequestReasonId:this.changeRequestData.DraftOfferPriceChangeRequestReasonId,
                    Reason:this.changeRequestData.Reason,
                    ReasonCode:this.changeRequestData.ReasonCode,
                    PriceStr:this.changeRequestData.PriceStr || null,
                    StartProvinceId: this.changeRequestData.Type == "ROUTE_ERROR" ? this.changeRequestData.Route.StartProvinceId || null : null,
                    StartProvinceName:this.changeRequestData.Type == "ROUTE_ERROR" ? Additional.ConvertPascalCaseSingleWorld(this.changeRequestData.Route.StartProvinceName) || null : null,
                    StartDistrictId:this.changeRequestData.Type == "ROUTE_ERROR" ? this.changeRequestData.Route.StartDistrictId || null: null,
                    StartDistrictName:this.changeRequestData.Type == "ROUTE_ERROR" ? Additional.ConvertPascalCaseSingleWorld(this.changeRequestData.Route.StartDistrictName) || null: null,
                    StartNeighborhoodId:this.changeRequestData.Type == "ROUTE_ERROR" ? this.changeRequestData.Route.StartNeighborhoodId || null: null,
                    StartNeighborhoodName:this.changeRequestData.Type == "ROUTE_ERROR" ? Additional.ConvertPascalCaseSingleWorld(this.changeRequestData.Route.StartNeighborhoodName) || null: null,
                    EndProvinceId:this.changeRequestData.Type == "ROUTE_ERROR" ? this.changeRequestData.Route.EndProvinceId || null: null,
                    EndProvinceName:this.changeRequestData.Type == "ROUTE_ERROR" ? Additional.ConvertPascalCaseSingleWorld(this.changeRequestData.Route.EndProvinceName) || null: null,
                    EndDistrictId:this.changeRequestData.Type == "ROUTE_ERROR" ? this.changeRequestData.Route.EndDistrictId || null: null,
                    EndDistrictName:this.changeRequestData.Type == "ROUTE_ERROR" ? Additional.ConvertPascalCaseSingleWorld(this.changeRequestData.Route.EndDistrictName) || null: null,
                    EndNeighborhoodId:this.changeRequestData.Type == "ROUTE_ERROR" ? this.changeRequestData.Route.EndNeighborhoodId || null: null,
                    EndNeighborhoodName:this.changeRequestData.Type == "ROUTE_ERROR" ? Additional.ConvertPascalCaseSingleWorld(this.changeRequestData.Route.EndNeighborhoodName) || null: null,
                    Unsaved: true,
                    Type:this.changeRequestData.Type,
                    Status: 0,
                })
            }
            this.$hideModal('change-request')
        },
        sendChangeRequests(){
            let requests = this.detail?.PricesOfRoutes.reduce((arr,r)=>{
                r.AllChangeRequests.filter(cr => cr.Unsaved).forEach(rr=>{
                    arr.push({
                        Id: rr.DBID,
                        DraftOfferPriceChangeRequestReasonId: rr.DraftOfferPriceChangeRequestReasonId,
                        Price: Number(rr?.PriceStr?.replace('.','').replace(',','.')) || null,
                        StartProvinceId:rr.StartProvinceId,
                        StartDistrictId:rr.StartDistrictId,
                        StartNeighborhoodId:rr.StartNeighborhoodId,
                        EndProvinceId:rr.EndProvinceId,
                        EndDistrictId:rr.EndDistrictId,
                        EndNeighborhoodId:rr.EndNeighborhoodId,
                        Description: rr.Description,
                    })
                })
                return arr
            },[])
            let data = { CustomerDraftOfferId: this.detail.CustomerDraftOfferId, RoutePricesChangeRequests:requests }
            this.loading = true
            CustomerApi.DraftOffer.ChangeRequest(data).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$router.push({name:'customer-draft-offer'})
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        deleteChangeRequest(req,item,index){
            let route = this.detail.PricesOfRoutes.find( r=> r.Id == req.Id)
            if(route && req.Type){
                if(req.Type == "KAMYON") this.$set(route,"KamyonStatus",1)
                else if(req.Type == "TREYLER") this.$set(route,"TreylerStatus",1)
                else if(req.Type == "KIRKAYAK") this.$set(route,"KirkayakStatus",1)
            }
            this.$delete(item.AllChangeRequests,index)
            this.$set(item,"Status",item.BaseStatus)
        },
        agreementVerification(){
            this.loading = true
            CustomerApi.DraftOffer.AgreementCode(this.id).then(res=>{
                if(res.data.Success){ this.$showModal('verification') }
                else{ this.$result(res) }
                this.loading = false
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        acceptAll(){
            this.accepting = true
            CustomerApi.DraftOffer.AcceptDraftPrice(this.id,this.codeData.code).then(res=>{
                this.$result(res)
                this.accepting = false
                if(res.data.Success){
                    this.$router.push({name:'customer-draft-offer'})
                }
            }).catch(err=>{
                this.$result(null,err)
                this.accepting = false
            })
        },
    },
    computed:{
        totalUnsavedChanges(){
            return this.detail?.PricesOfRoutes?.reduce((total,item)=>{
                total += item.AllChangeRequests.filter(cr=>cr.Unsaved).length
                return total
            },0) || 0
        },
        c_codeValid(){
            if(typeof this.codeData.code == 'string'){
                let codeSplit = this.codeData.code?.split('')
                if(codeSplit.length == 6) return true
                else return false
            }else return false
        },
        expired(){
            return this.detail.AgreementStep == 0 && this.detail.IsLastAnswerDateExpired == true
        }
    }
}
</script>

<style>
.sticky-alert{
    position: sticky;
    top: 1rem;
    box-shadow: 0 4px 24px rgb(255 159 67 / 50%)  !important;
}
</style>